import { requests } from '../index';
import URLS  from '../endPoints';
import request from 'superagent';

let jobDetails = {};
jobDetails.getsinglejob = async (id) => {
    return (await requests.get(URLS.magUrl.singlejob + id))

};



export default jobDetails;